<template>
  <div id="Security">
    <div class="header-security">Users</div>
    <div class="d-flex" v-for="item in usersData" :key="item.name">
      <p>{{ item.name }}</p>
      <p class="pl-10">{{ item.role }}</p>
      <a class="pl-10" href="">Delete</a>
    </div>
    <form class="form" @submit="onSubmit">
      <div class="form-input">
        <input
          type="text"
          class="input"
          placeholder="Username"
          v-model="usersInfo.name"
        />
        <b-select class="input ml-5 pa-5" v-model="usersInfo.role">
          <button style="background-color: #b9b9b9"></button>
          <option disabled value="">Please select one</option>
          <option v-for="role in roles" :key="role.name">
            {{ role.name }}
          </option>
        </b-select>
        <button class="add-users-btn ml-2" @click="onAddUsers()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30.295"
            height="30.908"
            viewBox="0 0 30.295 30.908"
          >
            <path
              d="M5,0H25.295a4.9,4.9,0,0,1,5,4.788V26.12a4.9,4.9,0,0,1-5,4.788H5A4.9,4.9,0,0,1,0,26.12V4.788A4.9,4.9,0,0,1,5,0Z"
              fill="#fff"
            />
            <g transform="translate(178.247 -1176.57)">
              <line
                x2="21.486"
                transform="translate(-174.247 1192.415)"
                fill="none"
                :stroke="color"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="3"
              />
              <line
                y2="21.486"
                transform="translate(-163.504 1181.671)"
                fill="none"
                :stroke="color"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="3"
              />
            </g>
          </svg>
          ADD USER
        </button>
      </div>

      <div class="button">
        <button
          type="button"
          class="button-edit mr-15"
          :class="{ inactive: editing }"
          @click="toggleEdit"
        >
          SAVE
        </button>
        <input
          type="submit"
          class="button-save"
          :disabled="!editing"
          value="CANCEL"
        />
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: " #8bc53f",
    },
  },
  data() {
    return {
      editing: false,
      username: "",
      selected: "",
      usersData: [],
      ownedBusiness: "",
      usersInfo: {
        name: null,
        role: null,
      },
      roles: [{ name: "Admin" }, { name: "Editor" }, { name: "Contributor" }],
    };
  },
  methods: {
    toggleEdit() {
      if (!this.editing) {
        this.editing = true;
      } else {
        this.rollback();
        this.editing = false;
      }
    },
    onAddUsers() {
      console.log(this.username);
      console.log(this.selected);
      this.usersData.push({ ...this.usersInfo });
      console.log(this.usersData);
    },
    rollback() {
      this.password = "";
    },
    onSubmit(ev) {
      ev.preventDefault();

      if (!this.editing) return;

      if (this.password) {
        this.$repo.user
          .changePassword(this.password)
          .then(() => {
            this.editing = false;
          })
          .catch(console.error);
      } else {
        // Show warning
      }
    },
    loadData() {
      // this.isLoading = true;
      this.$repo
        .getOwnedBusiness()
        .then((ownedBusiness) => {
          this.ownedBusiness = ownedBusiness;
          console.log(ownedBusiness);
        })
        .catch(console.error);
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style lang="scss" scoped>
#Security {
  .header-security {
    color: #58595b;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 40px;
  }

  .form {
    .form-input {
      margin-bottom: 8px;

      .input {
        font-size: 12px;
        padding: 12px;
        width: 380px;
      }
      .dropdown-role {
        width: 50%;
      }
    }

    .button {
      button,
      input[type="submit"] {
        width: 172px;
        height: 50px;
        background-color: var(--primary-color);
        color: #fff;
        border: 0;
        text-transform: uppercase;

        &:disabled,
        &.inactive {
          background-color: #b9b9b9;
        }
      }
    }

    .mr-15 {
      margin-right: 15px;
    }

    .mb-40 {
      margin-bottom: 40px;
    }

    .mb-30 {
      margin-bottom: 30px;
    }
  }

  .add-users-btn {
    background-color: var(--primary-color);
    color: #fff;
    padding: 1%;
    border-radius: 8px;
  }
}
</style>
